import React from 'react';
import { CONTACT_EMAIL, CONTACT_MAILTO, WHATSAPP_DISPLAY, whatsappUrl } from '../config/contact';

const WHATSAPP_URL = whatsappUrl('Hola Vekian Labs, quisiera más información sobre sus servicios.');

// Canales directos bajo un CTA de cierre. `showEmail` evita repetir el correo
// cuando el bloque ya lo muestra como enlace principal.
function ContactChannels({ className = '', showEmail = true, label = 'También puede escribirnos' }) {
  return (
    <ul className={`vk-channels ${className}`.trim()} aria-label='Canales de contacto'>
      {label && <li className='vk-channels__label'>{label}</li>}
      {showEmail && (
        <li>
          <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
        </li>
      )}
      <li>
        <a href={WHATSAPP_URL} target='_blank' rel='noopener noreferrer'>
          WhatsApp {WHATSAPP_DISPLAY}<span className='vk-sr-only'> (se abre en una nueva pestaña)</span>
        </a>
      </li>
      <li>Quito, Ecuador · atención remota, híbrida o presencial</li>
    </ul>
  );
}

export default ContactChannels;
